import { Organization } from '../../types/organization'
import ProcessCard from './ProcessCardNew'

interface Props {
  processes: {
    id: string
    year: string
    number: number
    organization: Organization
    createdAt: string
    description?: string
  }[]
}

export default function ProcessOverview({ processes }: Props) {
  return (
    <div>
      <div className="w-fit pl-2 text-black font-medium border-b-black border-b-2 mb-4">
        فرایند‌های در حال اجرا
      </div>

      <div
        className="grid auto-rows-max auto-cols-auto px-4 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        id="processes-list"
      >
        {processes
          ?.sort(
            (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          )
          .map((stage) => (
            <ProcessCard
              createdAt={stage.createdAt}
              description={stage.description}
              number={stage.number}
              organization={stage.organization}
              year={stage.year}
              id={stage.id}
              key={stage.id}
            />
          ))}
      </div>
    </div>
  )
}
